<template>
  <div class="wrapper">
    <Header class="header" @rental="rental" :type="'order'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="rental">
        <section>
          <div class="ac">
            <p class="txtXL">
              <strong>할인 혜택 없이</strong>
              <br />
              진행 하시겠어요?
            </p>
            <p class="txtM mt80">지금 회원가입하면 신규회원 쿠폰을 드립니다!</p>
            <ul class="couponList">
              <li>
                <a href="#link" class="block bgColor0">
                  <div class="inner">
                    <!-- <span class="copy">렌탈 3만원&구매 3만원 할인 쿠폰</span> -->
                    <strong class="copy">10만원 쿠폰팩</strong>
                    <span class="desc">유효기간 발급일로부터 30일</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div class="btnArea mt20">
            <button type="button" class="btn_p" @click="join">회원가입하고 쿠폰받기</button>
          </div>

          <div class="mt60 ac">
            <button type="button" class="links" @click="goPaymentStep1()">할인 받지 않고 진행하기</button>
          </div>
        </section>
        <MessagePop v-if="messagePop" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
        <ConfirmPop @cancel="cancel" @confirm="confirm" @close="close" v-if="confirmPop">
          <p v-html="msg"></p>
        </ConfirmPop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
//import * as customjs from '../../../../../static/js/m.front.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { RENTAL_ADD_CART } from '@/store/message.type.js';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'paymentGuestMain',
  components: {
    ConfirmPop,
    MessagePop,
  },
  data() {
    return {
      productCode: '',
      orderId: '',
      color: '',
      coupon: '',
      couponSerialNumber: '',
      confirmPop: false,
      msg: '',
    };
  },
  created() {
    this.productCode = this.$route.params.productCode;
    this.color = this.$route.params.productColors;
    this.coupon = this.$route.params.coupon;
    this.couponSerialNumber = this.$route.params.couponSerialNumber;
    this.order2_productOption1 = this.$route.params.order2_productOption1;
    this.order2_productOption2 = this.$route.params.order2_productOption2;
    this.order2_productOption3 = this.$route.params.order2_productOption3;
    this.saleAmount = this.$route.params.saleAmount;
    this.internalProdCode = this.$route.params.internalProdCode;
  },
  mounted() {
    this.getOrderId();
  },
  methods: {
    getOrderId() {
      ApiService.service('GET', '/order/id')
        .then(({ data }) => {
          this.orderId = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    goPaymentStep1() {
      this.$router.push({
        name: 'paymentStep1',
        params: {
          productCode: this.productCode,
          orderId: this.orderId,
          color: this.color,
          coupon: this.coupon,
          couponSerialNumber: this.couponSerialNumber,
          order2_productOption1: this.order2_productOption1,
          order2_productOption2: this.order2_productOption2,
          order2_productOption3: this.order2_productOption3,
          saleAmount: this.saleAmount,
          internalProdCode: this.internalProdCode,
        },
      });
    },
    join() {
      const paymentInfo = {
        productCode: this.productCode,
        color: this.color,
        coupon: this.coupon,
        couponSerialNumber: this.couponSerialNumber,
        orderId: this.orderId,
        order2_productOption1: this.order2_productOption1,
        order2_productOption2: this.order2_productOption2,
        order2_productOption3: this.order2_productOption3,
        saleAmount: this.saleAmount,
        internalProdCode: this.internalProdCode,
      };
      console.log(paymentInfo);
      this.$router.push({ name: 'joinStep1', params: { paymentInfo: paymentInfo } });
    },
    rental() {
      //장바구니에 담을건지 ConfirmPop 노출
      // this.popMsg = RENTAL_ADD_CART; // 렌탈시작은 GO_HOME 사용 ( MemberMain 등 )
      // customjs.lp.open('#confirmPop');
      this.msg = RENTAL_ADD_CART; // 렌탈시작은 GO_HOME 사용 ( MemberMain 등 )
      this.confirmPop = true;
    },
    cancel() {
      // 취소 선택시 페이지이동
      this.$router.replace('/');
    },
    close: function () {
      this.confirmPop = false;
    },
    confirm() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출 > 비회원은 장바구니가 없음.
      this.confirmPop = false;
      this.msg = '로그인이 필요한 페이지 입니다.';
      this.messagePop = true;
    },
    close() {
      this.confirmPop = false;
      this.messagePop = false;

      this.$router.replace('/');
    },
  },
};
</script>
